<template>
  <div class="transaction-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-date"></i> Project Report</span
        >

      </div>
      <div>
        <div class="search-area">
          <el-radio-group v-model="query.client" v-if="clientControl">
            <el-radio-button label="">All</el-radio-button>
            <el-radio-button label="1">Agent</el-radio-button>
            <el-radio-button label="0">Customer</el-radio-button>
          </el-radio-group>

          <el-date-picker
            v-model="dateSearch"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button slot="append" type="primary" icon="el-icon-search" @click="getProjectData()">Search</el-button>
          <el-button icon="el-icon-download" type="success" @click="Report()">Export</el-button>
        </div>


        <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="created_date" label="Create Date" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="created_time" label="Time" header-align="center" align="center" width="80"> </el-table-column>
          <el-table-column prop="status" label="Status" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="member_code" label="Member Code" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="120"> </el-table-column>
          <el-table-column prop="transactionID" label="Transaction ID" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="transactionType" label="Transaction Type" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="description" label="Description" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="project_name" label="Project Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="_3dsecure" label="3d Secure" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="customer_name" label="Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="currency" label="Currency" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="total_transaction" label="Total Transaction" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="volume" label="Volume" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="company_name" label="Agent Name" header-align="center" align="center" width="300"> </el-table-column>
          <el-table-column prop="card_type" label="Card Type" header-align="center" align="center" width="100"> </el-table-column>
          <el-table-column prop="transaction_channel" label="Transaction Channel" header-align="center" align="center" width="150"> </el-table-column>
          <el-table-column prop="region" label="Region" header-align="center" align="center" width="100"> </el-table-column>
        </data-tables>

      </div>
    </el-card>
  </div>
</template>

<script>
import { getProject, getProjectExcel } from '@/api/report'
import { currentDateTime, dateFormat } from '@/utils'
export default {
  props:{
    company: String,
    project:String,
    client:String,
    clientControl: {
      type: Boolean,
      default: false
    }
  },
  watch: {
      project(val, old) {
        this.query.project_uid = val;
        this.getProjectData();
      }
  },
  data(){
    return{
      dateSearch: "",
      tableData: [],
      loading: false,
      query: {
        company_uid: "",
        project_uid: "",
        from : "",
        to: "",
        client: this.client
      },
    }
  },
  methods:{
    getProjectData(){
      this.loading = true
      this.SelectDate();
      getProject(this.query).then(({result, data}) => {
        this.loading = false
        if(result){
          this.tableData = data
        }
      });
    },
    Report(){
      this.SelectDate();
      getProjectExcel(this.query)
    },
    SelectDate(){
      this.query.company_uid = this.company || ""
      this.query.project_uid = this.project || ""
      this.query.from = this.dateSearch[0] || currentDateTime("YYYY-MM-DD")
      this.query.to = this.dateSearch[1] || currentDateTime("YYYY-MM-DD")
    }
  },
  created(){
    // this.getProjectData()
  }
};
</script>

<style lang="scss">
.transaction-manager-container{
  .search-area{
    margin-bottom: 16px;
    button{
      margin-left: 10px;
      margin-bottom: 16px;
    }
    .el-date-editor{
      margin-bottom: 16px;
    }
    .el-radio-group{
      margin-top: 12px;
      margin-right: 10px;
      margin-bottom: 16px;
    }
  }
}
</style>